import Model from './Model';

export default class Contract extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'contract';
  }
}
